// extracted by mini-css-extract-plugin
export var callCard = "_s6-0";
export var callMessageButton = "_s6-1";
export var helpIcon = "_s6-3";
export var helpIconContainer = "_s6-4";
export var verticalDivider = "_s6-2";